import { render } from "./DThemeToggle.vue?vue&type=template&id=f2fa09a2"
import script from "./DThemeToggle.vue?vue&type=script&lang=js"
export * from "./DThemeToggle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__